import { render, staticRenderFns } from "./Advertisement.vue?vue&type=template&id=c3dfd568&scoped=true&"
import script from "./Advertisement.vue?vue&type=script&lang=js&"
export * from "./Advertisement.vue?vue&type=script&lang=js&"
import style0 from "./Advertisement.vue?vue&type=style&index=0&id=c3dfd568&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3dfd568",
  null
  
)

export default component.exports